import { render, staticRenderFns } from "./repair-request.vue?vue&type=template&id=3aeb5e12"
import script from "./repair-request.vue?vue&type=script&lang=js"
export * from "./repair-request.vue?vue&type=script&lang=js"
import style0 from "./repair-request.vue?vue&type=style&index=0&id=3aeb5e12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports